module.exports = {"gig_card":{}}


//////////////////
// WEBPACK FOOTER
// ./src/translations.en.json
// module id = eIBB
// module chunks = 0